<template>
    <v-dialog
        :value="isOpen"
        scrollable
        :max-width="'800px'"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template>
                        Edycja cen
                    </template>
                </h1>
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="priceComponents"
                :loading="componentsLoading"
                disable-pagination
                height="50vh"
                hide-default-footer
                :mobile-breakpoint="0"
            >
                <template #item.piecePrice="{item}">
                    <v-edit-dialog
                        v-if="isCalculationEditable"
                        persistent
                        large
                        cancel-text="Anuluj"
                        save-text="Zapisz"
                        @save="savePiecePrice(item)"
                    >
                        {{ formatPrice(item.piecePrice) }}
                        <v-icon color="blue" small>
                            mdi-pencil
                        </v-icon>
                        <template #input>
                            <v-text-field
                                v-model="item.piecePrice"
                                single-line
                            />
                        </template>
                    </v-edit-dialog>
                    <template v-else>
                        {{ formatPrice(item.piecePrice) }}
                    </template>
                </template>
                <template #item.totalPrice="{item}">
                    {{ formatPrice(item.totalPrice) }}
                </template>
            </v-data-table>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    v-if="isCalculationEditable"
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="actionLoading"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import parse from '@/mixins/parse'
import priceFormatter from '@/mixins/priceFormatter'
import { errorHandler } from '@/utils/errorHandler'

import { mask } from 'vue-the-mask'


export default {
    name: 'CalculationPriceMaterialDialog',
    directives: { mask },
    mixins: [ parse, priceFormatter ],
    props: {
        isOpen: {
            type: Boolean
        },
        calculationId: {
            type: Number,
            default: null
        },
        products: {
            type: Array,
            default: () => []
        },
        isCalculationEditable: {
            type: Boolean
        },
        actionLoading: {
            type: Boolean
        }
    },
    data() {
        return {
            componentsLoading: true,
            priceComponents: [],
            changedComponents: {},
            headers: [
                {
                    text: 'Montaż',
                    value: 'number',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'Składnik',
                    value: 'componentName',
                    sortable: false
                },
                {
                    text: 'Nazwa',
                    value: 'name',
                    sortable: false
                },
                {
                    text: 'Ilość',
                    value: 'amount',
                    sortable: false
                },
                {
                    text: 'Cena jednostkowa',
                    value: 'piecePrice',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'Wartość',
                    value: 'totalPrice',
                    sortable: false
                }
            ]
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.$store.dispatch('calculations/getCalculationImpositionTaskPriceComponents', this.calculationId)
                    .then(response => {
                        response.data.results.forEach(item => {
                            if (item.amount) {
                                this.priceComponents.push({
                                    id: item.id,
                                    name: item.name,
                                    value: item.value,
                                    amount: item.amount,
                                    hourPrice: item.hourPrice,
                                    piecePrice: item.piecePrice,
                                    number: item.calculationImpositions,
                                    totalPrice: item.piecePrice * item.amount,
                                    componentName: item.priceComponentType.verboseName
                                })
                            }
                        })
                    })
                    .catch(error => {
                        errorHandler(error)
                    })
                    .finally(() => {
                        this.componentsLoading = false
                    })
            } else {
                this.priceComponents = []
                this.changedComponents = {}
            }
        }
    },
    methods: {
        savePiecePrice(item) {
            item.piecePrice = parseFloat(item.piecePrice.replace(/,/g, '.'))
            item.totalPrice = item.piecePrice * item.amount

            this.changedComponents[item.id] = item.piecePrice
        },
        onSave() {
            Object.keys(this.changedComponents).forEach(id => {   
                this.componentsLoading = true             
                this.$store.dispatch('calculations/updateCalculationImpositionTaskPriceComponents', {
                    id: id,
                    calculation_pk:  this.calculationId,
                    piecePrice: this.changedComponents[id]
                }).finally(() => {
                    this.componentsLoading = false
                })
            })
            this.onClose()
        },
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>